module.exports = __webpack_public_path__ + "static/media/S2N10-2.f40a3747.svg";